var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-bar"},_vm._l((_vm.tabs),function(ref,i){
var icon = ref.icon;
var routeName = ref.routeName;
return _c('TabBarIcon',{key:("tab-bar-icon-" + i),attrs:{"icon":icon,"routeName":routeName}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }